(function($, window) {
    $(document).on('click', '[data-cart-item-toggle="remove"]', function() {
        var item = $(this).parents('[data-cart-item]').eq(0);
        var success = false;

        $.ajax({
            url: _AVENCY_BASE_actions.cart.removeCartItem,
            type: 'POST',
            data: {
                cartItemIdentifier: item.data('cartItemIdentifier'),
                __csrfToken: window._AVENCY_SHOP_csrfToken
            }
        }).done(function(data) {
            if (data.status === 'success') {
                $('[data-cart-price]').text(data.cartPriceFormatted);
                item.remove();
                showAndReloadCartSmall();
                success = true;
            }
        }).always(function() {
            if (success) {
                iziToast.show({
                    class: 'iziToast-success',
                    animateInside: false,
                    progressBar: false,
                    timeout: 3200,
                    transitionIn: 'fadeInLeft',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut',
                    icon: 'ai ai-checkmark-circle2',
                    message: _AVENCY_BASE_translations.cart.item.remove.success,
                    position: 'topRight'
                });
            } else {
                iziToast.show({
                    class: 'iziToast-danger',
                    animateInside: false,
                    progressBar: false,
                    timeout: 9000,
                    transitionIn: 'fadeInLeft',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut',
                    icon: 'ai ai-circle-minus',
                    message: _AVENCY_BASE_translations.cart.item.remove.error,
                    position: 'topRight'
                });
            }
        });
    });
})(jQuery, window);
